import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Divider } from "@gemini/ui";
import { useEnergyCost } from "@/components/Sections/Energy/EnergyCost";
export const EnergyCost = ({ certificate }) => {
    const { estimationLabel, estimationValue, estimationDescription } = useEnergyCost(certificate);
    if (!estimationValue)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { typography: "typography.body.16.bold", marginBottom: "spacing.16", children: estimationLabel }), _jsx(Box, { backgroundColor: "color.background.light", padding: "spacing.8", borderRadius: "radius.8", gap: "spacing.8", typography: "typography.body.16.bold", marginBottom: "spacing.8", children: estimationValue }), _jsx(Box, { typography: "typography.body.14.regular", children: estimationDescription }), _jsx(Divider, { marginVertical: "spacing.24" })] }));
};
